import React from 'react';

const InventoryIcon = () => {
  return (
    <div>
      <svg
        width='81'
        height='80'
        viewBox='0 0 81 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_42_86)'>
          <rect x='0.5' width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M29.3636 58.8036V36.3995C29.3636 35.9424 29.5312 35.5041 29.8296 35.1809C30.128 34.8577 30.5326 34.6761 30.9545 34.6761H50.0455C50.4674 34.6761 50.872 34.8577 51.1704 35.1809C51.4688 35.5041 51.6364 35.9424 51.6364 36.3995V59M35.7273 58.8228V50.1867C35.7273 49.7296 35.8949 49.2912 36.1932 48.968C36.4916 48.6448 36.8962 48.4633 37.3182 48.4633H43.6818C44.1038 48.4633 44.5084 48.6448 44.8068 48.968C45.1051 49.2912 45.2727 49.7296 45.2727 50.1867V58.8228M39.9591 21.1027L24.05 27.3689C23.7425 27.4894 23.4768 27.7095 23.2889 27.9993C23.101 28.2892 23.0001 28.6347 23 28.9889V57.0802C23 57.5373 23.1676 57.9757 23.466 58.2989C23.7643 58.6221 24.169 58.8036 24.5909 58.8036H56.4091C56.831 58.8036 57.2357 58.6221 57.534 58.2989C57.8324 57.9757 58 57.5373 58 57.0802V28.9889C57.9999 28.6347 57.899 28.2892 57.7111 27.9993C57.5232 27.7095 57.2575 27.4894 56.95 27.3689L41.0409 21.1027C40.6914 20.9658 40.3086 20.9658 39.9591 21.1027Z'
            stroke='#FEFEFE'
            stroke-width='1.5'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_42_86'
            x='-3.92632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_42_86'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default InventoryIcon;
